import { ComponentProps, FC } from 'react';
import { twMerge } from 'tailwind-merge';

type ToggleProps = {
  label?: string;
  labelPosition?: 'start' | 'end';
  labelWrapperClassName?: string;
} & ComponentProps<'input'>;

export const Toggle: FC<ToggleProps> = ({ label, labelPosition = 'start', labelWrapperClassName, checked, disabled, ...rest }) => {
  const labelElement = <span className={twMerge('text-gray-700', labelWrapperClassName)}>{label}</span>;

  return (
    <label className={twMerge('flex cursor-pointer items-center gap-2', disabled && 'cursor-not-allowed')}>
      {labelPosition === 'start' && labelElement}
      <div className='relative'>
        <input {...rest} type='checkbox' checked={checked} disabled={disabled} className='sr-only' />
        <div className={twMerge('w-9 h-5 rounded-full transition-colors duration-300', checked ? 'bg-brand-600' : 'bg-gray-700')}></div>
        <div
          className={twMerge(
            'absolute top-0.5 left-0.5 w-4 h-4 bg-white-100 rounded-full shadow transition-transform duration-300',
            checked ? 'translate-x-4' : ''
          )}
        ></div>
      </div>
      {labelPosition === 'end' && labelElement}
    </label>
  );
};
